import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=b612083a&scoped=true"
import script from "./WorkInProgress.vue?vue&type=script&lang=js"
export * from "./WorkInProgress.vue?vue&type=script&lang=js"
import style0 from "./WorkInProgress.vue?vue&type=style&index=0&id=b612083a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612083a",
  null
  
)

export default component.exports